import AuthRoute from './AuthRoute';
import PrivateRoute from './PrivateRoute';
import JourneyRoute from './JourneyRoute';

export { AuthRoute, PrivateRoute, JourneyRoute };



// WEBPACK FOOTER //
// ./src/routes/components/index.js